import { editionForPath } from "./edition.ts";
import { isAwaiting, readModelFor, type SiteModels } from "./readModels.ts";
import { Shell, NotFound, AwaitingPublication } from "./components/Shell.tsx";
import { CoreLanding } from "./pages/CoreLanding.tsx";
import { ConstructPage } from "./pages/ConstructPage.tsx";
import { AccentureLanding } from "./pages/AccentureLanding.tsx";

const FALLBACK_FOOTER = { tagline: "Goals. Realized.", credit: "A Beyond Labs release. Part of the Beyond Work family." };

export function WorkableSite({ path, models }: { path: string; models?: SiteModels }) {
  const { edition, rest } = editionForPath(path);
  const model = readModelFor(edition, models);

  if (isAwaiting(model)) {
    const known = rest === "/" || rest === "" || rest === "/constructs" || rest === "/constructs/";
    return (
      <Shell edition={edition} tagline={FALLBACK_FOOTER.tagline} credit={FALLBACK_FOOTER.credit} published={false}>
        {known ? <AwaitingPublication edition={edition} /> : <NotFound path={path} />}
      </Shell>
    );
  }

  const { products, expression } = model;
  const edition_ = model.edition_;

  let content: React.ReactNode;
  if (rest === "/" || rest === "") {
    content = edition === "accenture"
      ? <AccentureLanding model={model} />
      : <CoreLanding products={products} expression={expression} />;
  } else if (rest === "/constructs" || rest === "/constructs/") {
    content = <CoreLanding products={products} expression={expression} />;
  } else {
    const slug = rest.match(/^\/constructs\/([a-z0-9-]+)\/?$/)?.[1];
    const construct = slug ? products.constructs.find((c) => c.slug === slug) : undefined;
    content = construct
      ? <ConstructPage construct={construct} edition={edition} accentureAdaptations={edition_?.constructAdaptations} />
      : <NotFound path={path} />;
  }

  return (
    <Shell edition={edition} tagline={expression.footer.tagline} credit={expression.footer.credit}>
      {content}
    </Shell>
  );
}
